import { useState } from "react";
import printJS from "print-js";
import PrintablePatient from "./PrintablePatient";

export default function PatientPreview({ patient, onEdit, onClose }) {
  const clinicalKeys = [
    "presentcomplaint", "pasthistory", "head", "eyes", "ears", "mouth",
    "nose", "throat", "chest", "abdomen", "appetite", "thrist", "urine",
    "stool", "sleep", "mind", "ext", "skin", "sweat", "female", "thermal",
    "investigation", "face", "physiology", "familyhistory", "male", "treatment"
  ];

  const nonEmptyKeys = clinicalKeys.filter(k => patient[k]?.trim?.());
  const [selectedKeys, setSelectedKeys] = useState(new Set(nonEmptyKeys));

  const toggleKey = (key) => {
    const updated = new Set(selectedKeys);
    if (updated.has(key)) updated.delete(key);
    else updated.add(key);
    setSelectedKeys(updated);
  };

  const selectAll = () => setSelectedKeys(new Set(nonEmptyKeys));
  const deselectAll = () => setSelectedKeys(new Set());

  const handlePrint = () => {
    printJS({
      printable: "printable-section",
      type: "html",
      targetStyles: ["*"],
      documentTitle: `${patient.registration_number}_${patient.firstname}_${patient.lastname}`,
    });
  };

  return (
    <>
      <div className="print:hidden mb-4">
        <h2 className="text-lg font-semibold mb-2">Select Clinical Fields to Include:</h2>
        <div className="flex flex-wrap gap-3 max-h-40 overflow-y-auto mb-2">
          {clinicalKeys.map((key) => {
            const label = key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase());
            const disabled = !patient[key]?.trim?.();
            return (
              <label key={key} className={`flex items-center gap-1 text-sm ${disabled ? "opacity-50" : ""}`}>
                <input
                  type="checkbox"
                  disabled={disabled}
                  checked={selectedKeys.has(key)}
                  onChange={() => toggleKey(key)}
                />
                {label}
              </label>
            );
          })}
        </div>

        <div className="flex gap-2 mb-4">
          <button onClick={selectAll} className="px-2 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700">Select All</button>
          <button onClick={deselectAll} className="px-2 py-1 text-sm bg-yellow-600 text-white rounded hover:bg-yellow-700">Deselect All</button>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => onEdit(patient)}
            className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            ✏️ Edit
          </button>
          <button
            onClick={handlePrint}
            className="px-4 py-1 bg-gray-700 text-white rounded hover:bg-gray-800"
          >
            🖨️ Print / Save PDF
          </button>
          <button
            onClick={onClose}
            className="px-4 py-1 bg-red-600 text-white rounded hover:bg-red-700"
          >
            ✖️ Close
          </button>
        </div>
      </div>

      <div id="printable-section">
        <PrintablePatient patient={patient} selectedKeys={selectedKeys} />
      </div>
    </>
  );
}
